import { createSelector } from '@reduxjs/toolkit';
import selectUploads from './selectUploads';

export default createSelector(selectUploads, (uploads) => Object.values(uploads));
